// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdGranularPermissionOptInStatusResult = objectOf({
  migration_active: boolean,
});
